export default __webpack_public_path__ + "images/penalty_missed.fe0563.png";